const addProductToCart_Request = async (
  variantID,
  quantity,
  cartID,
  sellingPlanId,
  custom_option = []
) => {
  try {
    let localCartID = ""
    if(cartID) {
      localCartID = cartID;
    } else {
      localCartID = await getCartId();
    }
    console.log("localCartID for add product", localCartID)
    const Body = `
    mutation cartLinesAdd($lines: [CartLineInput!]!, $cartId: ID!) {
      cartLinesAdd(lines: $lines, cartId: $cartId) {
        cart {
          id
          discountCodes{code}
            checkoutUrl
            lines(first:100) {
              edges {
                node {
                  id
                  quantity
                  attributes{
                    key
                    value
                  }
                  estimatedCost {
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                  }
                  sellingPlanAllocation {
                      sellingPlan {
                          id
                          name
                      }
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      sku
                      image{
                        url
                      }
                      priceV2{
                        amount
                      }
                      product{
                        id
                        vendor
                        title
                        handle
                        onlineStoreUrl
                        giftProductID: metafield(namespace: "free_gift", key: "product_variant_id") {
                          value
                        }
                        bundleTitle: metafield(namespace: "bundle_title", key: "free_gift") {
                          value
                        }
                      }
                      selectedOptions{
                        name
                        value
                      }
                    }
                  }
                }
              }
            
            }
          estimatedCost {
            subtotalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
          code
        }
      }
    }  
    `;
    const Variables = {
      lines: [
        {
          merchandiseId: variantID,
          quantity: parseInt(quantity),
          attributes: custom_option,
          ...(sellingPlanId && { sellingPlanId: sellingPlanId }),
        },
      ],
      cartId: localCartID,
    };

    const data = await CertorgraphqlPostRequest(Body, Variables);
    console.log(data);
    if (data?.data?.cartLinesAdd?.cart?.id) {
      cartItems = data.data.cartLinesAdd;
    }

    if (data?.data?.cartLinesAdd.userErrors.length !== 0) {
      console.log(
        "error while addind item to cart : ====>",
        data?.data?.cartLinesAdd.userErrors
      );

      // if shopify respond with cartid not existed and return a new cart id contained the item
      if (data?.data?.cartLinesAdd.userErrors[0].field[0] === "cartId") {
        console.log("new cart ", data?.data?.cartLinesAdd?.cart?.id);
        saveNewCartOnfirebaseAndCookies(data?.data?.cartLinesAdd?.cart?.id);
        return true;
      }

      if (data?.data?.cartLinesAdd.userErrors[0].field.includes("quantity")) {
        trigger_cutomeEvent.CartNotification_error(
          data?.data?.cartLinesAdd.userErrors[0].message
        );
      }
      return false;
    }

    setCookie("cartID", cartID, 10);
    return data.data || false;
  } catch (error) {
    return false;
  }
};

const updateProductToCart_Request = async (
  variantID,
  quantity,
  cartID,
  custom_option
) => {
  try {
    let localCartID = ""
    if(cartID) {
      localCartID = cartID;
    } else {
      localCartID = await getCartId();
    }
    const Body = `
    mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $cartId, lines: $lines) {
        cart {
          id
          discountCodes{code}
            checkoutUrl
            lines(first:100) {
              edges {
                node {
                  id
                  quantity
                  attributes{
                    key
                    value
                  }
                  estimatedCost {
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                  }
                  sellingPlanAllocation {
                      sellingPlan {
                          id
                          name
                      }
                  }
                  merchandise {
                    ... on ProductVariant {
                      id
                      sku
                      image{
                        url
                      }
                      priceV2{
                        amount
                      }
                      product{
                        id
                        vendor
                        title
                        handle
                        onlineStoreUrl
                        giftProductID: metafield(namespace: "free_gift", key: "product_variant_id") {
                          value
                        }
                        bundleTitle: metafield(namespace: "bundle_title", key: "free_gift") {
                          value
                        }
                      }
                      selectedOptions{
                        name
                        value
                      }
                    }
                  }
                }
              }
            
            }
          estimatedCost {
            subtotalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
          code
        }
      }
    }
  `;
    const Variables = {
      lines: {
        id: variantID,
        quantity: parseInt(quantity),
        attributes: custom_option,
      },
      cartId: localCartID,
    };
    const data = await CertorgraphqlPostRequest(Body, Variables);
    console.log(data);
    if (data?.data?.cartLinesUpdate?.cart?.id) {
      cartItems = data.data.cartLinesUpdate;
    }

    if (data?.data?.cartLinesUpdate.userErrors.length !== 0) {
      console.log(
        "error while addind item to cart : ====>",
        data?.data?.cartLinesUpdate.userErrors
      );

      // if shopify respond with cartid not existed and return a new cart id contained the item
      if (data?.data?.cartLinesUpdate.userErrors[0].field[0] === "cartId") {
        console.log("new cart ", data?.data?.cartLinesUpdate?.cart?.id);
        saveNewCartOnfirebaseAndCookies(data?.data?.cartLinesUpdate?.cart?.id);
        return true;
      }

      if (data?.data?.cartLinesUpdate.userErrors[0].field) {
        trigger_cutomeEvent.CartNotification_error(
          data?.data?.cartLinesUpdate.userErrors[0].message
        );
      }
      return false;
    }
    return data?.data || false;
  } catch (error) {
    return false;
  }
};

const getProductVarient = async (handleName, SKU) => {
  try {
    const Body = `
            query getProductVarient($SKU: String!) {
                products(first: 50 , query:$SKU) {
                    edges {
                    node {
                      id
                      title
                      handle
                      metafield(namespace:"custom",key:"lead_time"){
                        value
                      }
                      variants(first: 100) {
                        edges {
                          node {
                            sku
                            id
                          }
                        }
                      }
                    }
                  }
                }
            }
          `;
    const Variables = {
      SKU: SKU,
    };
    const data = await CertorgraphqlPostRequest(Body, Variables);

    const variants = data.data.products?.edges[0]?.node?.variants.edges;
    const correctVariant = variants.filter((variant) => {
      return variant.node.sku === SKU;
    });
    return {
      variantID: correctVariant[0]?.node?.id,
      metafield: data.data.products?.edges[0]?.node?.metafield?.value,
    };
  } catch (error) {
    console.log("getProductVarient =====>", error);
    return false;
  }
};

document.addEventListener("variant:added", async (event) => {
  try {
    console.log("variant:added")
    let lead_time_metafield = product_lead_time
      ? { key: "Lead Time", value: product_lead_time }
      : null;

    let cartTotal;
    var variant = event.detail.variant; // Get the variant that was added
    // const parallelProductVariantID = variable_meta_data_set[variant.sku.value];
    const parallelProductVariantID = "gid://shopify/ProductVariant/" + variant.id.value;
    // add gid// prefix to line ID
    console.log("variant:add detail ===> ",  event.detail.variant)
    // to address variant id => variant.id.value
    const quantityElement = document.getElementsByName("quantity")[0];
    const quantity = quantityElement?.value || 1;
    console.log("variable_meta_data_set", variable_meta_data_set)
     console.log("parallelProductVariantID ===>", parallelProductVariantID);
    console.log("lead_time_metafield", lead_time_metafield)
    if(lead_time_metafield){
      try {
        const variantQuantiy = await getVariantData(parallelProductVariantID)
        console.log(variantQuantiy)
        if(variantQuantiy.quantityAvailable > 0){
          lead_time_metafield = null
        }
      } catch (error) {
       console.log(error) 
      }
    }
    const ymq_box = document.getElementById("ymq-box");
    console.log("ymq_box", ymq_box)
    if (ymq_box) {
      // get all product options
      const custom_option = Array.from(
        document.getElementsByClassName("item")
      ).map((Option) => {
        return {
          key: Option.querySelector("span").innerText,
          value: Option.querySelector("strong").innerText,
        };
      });

      const price = helper.getAddonsPrice();

      lead_time_metafield && custom_option.push(lead_time_metafield);

      cartTotal = await addProductToCart_Request(
        findVariantID(price, "schuttsports"),
        1,
        globalCartID_Cookies,
        sellingPlanID,
        custom_option
      );
    } else {
      // console.log("quantity1 ====>",quantity1)
      if (!parallelProductVariantID) {
        console.log("can't find parallelProductVariantID");
        return false;
      }
      console.log("sellingPlanID ====>", sellingPlanID)
      const sellingPlan = event.detail.variant?.selling_plan?.value ? "gid://shopify/SellingPlan/"+event.detail.variant.selling_plan.value : ""
      cartTotal = await addProductToCart_Request(
        parallelProductVariantID,
        quantity,
        globalCartID_Cookies,
        sellingPlan,
        lead_time_metafield ? lead_time_metafield : []
      );
      console.log("cartTotal", cartTotal)
    }
    //parallelProductVariantID &&
    //  (await giftProduct_functions.addGiftProduct(
    //    variant?.product_id?.value,
    //    quantity
    //  ));

    if (!cartTotal) {
      giftProduct_functions.giftProduct_validationCheck(
        cartItems?.cart?.lines?.edges
      );
      trigger_cutomeEvent.CartNotification_error("This Product Not Availble");
      return false;
    }
    const CartTotalAmount = `${parseFloat(
      cartTotal?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount?.amount
    ).toFixed(2)} ${
      cartTotal?.cartLinesAdd?.cart?.estimatedCost?.subtotalAmount?.currencyCode
    }`;
    updateCheckoutButtonMinicart(CartTotalAmount);
    trigger_cutomeEvent.globalVariant_add();
    //deactivateCartLoader();
     // display_mini_cart_items();
  } catch (error) {
    console.log("variant:added error =====>", error);

    return false;
  }
});
